// API 配置文件
const isDev = process.env.NODE_ENV === 'development'
const defaultLocalDownloadApi = 'https://h55.futoit.com/local-download/api/v1'
const devLocalDownloadApi = process.env.VUE_APP_LOCAL_DOWNLOAD_API || '/local-download/api/v1'
const prodLocalDownloadApi = process.env.VUE_APP_LOCAL_DOWNLOAD_API || defaultLocalDownloadApi

//https://minideline.futoit.com

export default {
  // 主要业务API地址
  baseURL: (process.env.VUE_APP_BACKEND_URL || 'https://minideline.futoit.com'),

  // AvatarFlow数字人API地址（开发和生产环境都使用h55服务器）
  avatarflowApi: process.env.VUE_APP_AVATARFLOW_URL || 'https://h55.futoit.com',

  // 本地下载服务地址
  localDownloadApi: isDev ? devLocalDownloadApi : prodLocalDownloadApi,

  // 请求配置
  timeout: 150000,        // 15秒超时
  uploadTimeout: 300000, // 5分钟超时，用于文件上传
  retryTimes: 3,         // 重试3次
  retryDelay: 1000       // 重试间隔1秒
}
